module.exports = __webpack_public_path__ + "img/infraicon6.a517104c.svg";